/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "446")




export interface API50856Req {
  
  /** 任务id */
  taskId?: number;
  /** 任务反馈内容 */
  feedback?: string;
};



export interface API50856Res {
  /**   */
  code?: string;
  /**   */
  msg?: string;
  /**   */
  success?: boolean;
  /** data  */
  data?: boolean;
  /**   */
  exceptionMsg?: string;
  
};


// 50856 提交反馈

export interface IUsePostAPI50856Return {
  /** 提交反馈: 接口请求状态 */
  isAPI50856Loading: boolean;
  /** 提交反馈: 接口请求返回数据 */
  dataAPI50856: API50856Res;
  /**  提交反馈: 接口数据请求方法 */
  fetchAPI50856Data:  (inputs: API50856Req, config?: YWRequestConfig) => Promise<API50856Res>;
  /** 提交反馈: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI50856 = ():IUsePostAPI50856Return => {
  let isMount = true;
  const [isAPI50856Loading, setIsAPI50856Loading] = useState(false);
  const [dataAPI50856, setDataAPI50856] = useState<API50856Res>({} as API50856Res);
  const requestUrl = `${basePath}/team-work/workTask/submitFeedback`;

  const fetchAPI50856Data = async (inputs: API50856Req, config?: YWRequestConfig): Promise<API50856Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API50856Req>) || {}) as API50856Req;
    
  
    if ( isMount ) {
      setIsAPI50856Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API50856Res>(`${basePath}/team-work/workTask/submitFeedback`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI50856(res || {} as API50856Res);
        setIsAPI50856Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI50856Loading(false);
      }
      return false as unknown as API50856Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI50856Loading,
    dataAPI50856,
    fetchAPI50856Data,
    requestUrl,
  }
}

